import React from 'react';
import { motion } from 'framer-motion';
import { INCLUDED } from '../data/content';
import { Check } from 'lucide-react';

export default function EverythingIncluded() {
  return (
    <section className="py-24 md:py-32 bg-page">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="section-label">{INCLUDED.eyebrow}</div>
            <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] mt-5">
              {INCLUDED.title}
              <span className="grad-text-red">{INCLUDED.titleAccent}</span>
            </h2>
            <p className="mt-6 text-[16px] text-[color:var(--muted)] leading-relaxed max-w-md">{INCLUDED.intro}</p>
            <div className="mt-10 flex items-baseline gap-3">
              <div className="font-display text-[72px] leading-none text-[color:var(--ink)]">1</div>
              <div>
                <div className="font-display text-[22px]">program.</div>
                <div className="font-display text-[22px] grad-text-red">everything you need.</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ul className="divide-y divide-[color:var(--line)] border-t border-b border-line">
              {INCLUDED.items.map((it, i) => (
                <motion.li
                  key={it}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: '-40px' }}
                  transition={{ duration: 0.4, delay: i * 0.04 }}
                  className="py-5 flex items-center gap-5"
                >
                  <span className="w-9 h-9 rounded-full bg-red-soft flex items-center justify-center flex-shrink-0">
                    <Check size={18} className="text-red" />
                  </span>
                  <span className="font-display text-[18px] md:text-[20px]">{it}</span>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
